import { useCallback } from 'react';
import { Paragraph, Title } from '@components';
import { useTranslation } from '@utils/index';
import { InfoArea, Proposition } from '@ts/contentful';
import styles from './SunTopInfoArea.module.scss';

const getTranslatedTexts = translator => {
	return {
		aboutOurSunTops: translator('about-our-sun-tops'),
	};
};

export type SunTopInfoAreaProps = InfoArea;
const SunTopInfoArea = ({ propositions = [], title }: SunTopInfoAreaProps) => {
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);

	const ListElement = useCallback(
		({ proposition: { src, title, copy } }: { proposition: Proposition }) => (
			<li key={title} className={styles.listItem}>
				<img src={src} alt={title} height={96} width={96} />
				<div className={styles.descriptionContainer}>
					<Title>{title}</Title>
					<Paragraph>{copy}</Paragraph>
				</div>
			</li>
		),
		[]
	);

	return (
		!!propositions.length && (
			<section className={styles.container} data-section-name='value-proposition'>
				<Title>{title ?? translations.aboutOurSunTops}</Title>
				<ul>
					{propositions.map(({ copy, title, src }) => (
						<ListElement
							key={title}
							proposition={{
								copy,
								title,
								src,
							}}
						/>
					))}
				</ul>
			</section>
		)
	);
};

export default SunTopInfoArea;
